import React from "react"
import PropTypes from "prop-types"


class LexicoinItem  extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    return(
      <div
        style={{
          backgroundColor: '#C5B7FF',
          width: 160,
          height: 120,
          borderRadius: 10,
          cursor: 'pointer'
        }}
        onClick={this.props.onClick}>
        <h4 style={{marginBottom: 5, marginTop: 5, color: 'white', fontWeight: 'bold'}}>{this.props.title}</h4>
        <div className={this.props.imageName}></div>
        <p style={{marginTop: 8, color: 'white', textAlign: 'right', marginRight: 8}}>{this.props.price}</p>
      </div>
    )
  }
}

export default LexicoinItem
